import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getDocuments } from '../../../redux/actions';

class Help extends Component {

    constructor(props) {
		super(props);
		this.state = {
			errorMessage: ''
		}
    }

	componentDidMount() {
		let { resources } = this.props.state;
		var self = this;
		self.setState({
			errorMessage: ''
		});
		if(!resources.documents) {
			// second param says whether it needs to be saved into store
			self.props.getDocuments(`requestType=help&pageName=${self.props.routeParams.pageName}`, true, response => {
				if(!response.status) {
					self.setState({
						errorMessage: 'Error occured while fetching documents.'
					})
				}
			});
		}
	}

    render() {
		const { resources } = this.props.state;
        return (
            <div>
                <div className="push">
                    <h1 className="pageTitle">Need Help?</h1>
                    <p>Select a topic from the list below to view a quick tutorial.</p>
                </div>
				<p className="bold red">{this.state.errorMessage}</p>
                <table className="dataTable cartTable borderTable" style={{ width: '60%' }}>
                    <thead>
                        <tr>
                            <th>Tutorial</th>
                            <th>File Type</th>
                        </tr>
                    </thead>
                    <tbody>
						{resources.documents && resources.documents.responseObject && resources.documents.responseObject.map((item, index) => {
							if(!item.file) return null;
							const splitFileName = item.file.split('.'),
								extension = splitFileName[splitFileName.length - 1];
							return <tr key={index}>
								<td><a href={item.url} target="_blank">{item.file.replace('.' + extension, '')}</a></td>
								<td>{extension.toUpperCase()}</td>
							</tr>
						})}
						{resources.documents && resources.documents.responseObject && resources.documents.responseObject.length === 0
							?<tr><td colSpan={2}><h2>No help documents found for this page.</h2></td></tr>
							:null
						}
                    </tbody>
                </table>
            </div>
        );
    }
};
const mapStateToProps = (state) => {
    return { state };
};

const mapDispatchToProps = (dispatch) => ({
	getDocuments: (queryStringParams, willSaveToStore, callback) => dispatch(getDocuments(queryStringParams, willSaveToStore, callback)),
});

Help = connect(mapStateToProps, mapDispatchToProps)(Help);
export default Help;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Help/index.js